function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import { renderless, api } from "@opentiny/vue-renderless/tooltip/vue";
import { defineComponent, $prefix, $props, setup as _setup, createComponent, mergeClass, parseVnode } from "@opentiny/vue-common";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var classes = {
  "tooltip": "absolute -left-[9999px] py-2 px-3 sm:py-1.5 sm:px-2 text-sm sm:text-xs bg-color-text-primary text-color-text-inverse shadow-none sm:bg-color-bg-1 sm:text-color-text-primary sm:shadow-md leading-tight min-w-[3.75rem] max-w-[28.125rem] z-[2000] break-words rounded [&[x-placement^=top]]:mb-2.5 [&[x-placement^=bottom]]:mt-2.5 [&[x-placement^=right]]:ml-2.5 [&[x-placement^=left]]:mr-2.5",
  "arrow": 'drop-shadow-none absolute block w-0 h-0 border-[0.375rem] border-transparent border-solid after:absolute after:block after:w-0 after:h-0 after:border-[0.3125rem] after:border-transparent after:border-solid after:content-[""]',
  "placement-top": "sm:drop-shadow-[0_2px_2px_rgba(0,0,0,0.08)] -bottom-3 border-t-color-text-primary sm:border-t-color-bg-1 border-b-w-0 sm:after:border-t-color-bg-1 after:-bottom-1 after:-ml-1.5 after:border-t-color-text-primary after:border-b-w-0",
  "placement-bottom": "sm:drop-shadow-[0_-2px_2px_rgba(0,0,0,0.08)] -top-3 border-t-w-0 border-b-color-text-primary sm:border-b-color-bg-1 sm:after:border-b-color-bg-1 after:-top-1 after:-ml-1.5 after:border-t-w-0 after:border-b-color-text-primary",
  "placement-right": "sm:drop-shadow-[-2px_0px_2px_rgba(0,0,0,0.08)] -left-3 border-r-color-text-primary border-l-w-0 sm:border-r-color-bg-1 sm:after:border-r-color-bg-1 after:-bottom-1 after:-left-1 after:border-r-color-text-primary after:border-l-w-0",
  "placement-left": "sm:drop-shadow-[2px_0_2px_rgba(0,0,0,0.08)] -right-1.5 border-l-color-text-primary border-r-0 sm:border-l-color-bg-1 sm:after:border-l-color-bg-1 after:-bottom-1 after:right-px after:-ml-1.5 after:border-l-color-text-primary after:border-r-0",
  "placement-top-light": "border-t-color-bg-1 drop-shadow-[0_2px_2px_rgba(0,0,0,0.08)] after:border-t-color-bg-1",
  "placement-bottom-light": "border-b-color-bg-1 drop-shadow-[0_-2px_2px_rgba(0,0,0,0.08)] after:border-b-color-bg-1",
  "placement-left-light": "border-l-color-bg-1 drop-shadow-[2px_0_2px_rgba(0,0,0,0.08)] after:border-l-color-bg-1",
  "placement-right-light": "border-r-color-bg-1 drop-shadow-[-2px_0px_2px_rgba(0,0,0,0.08)] after:border-r-color-bg-1",
  "placement-top-dark": "border-t-color-text-primary after:border-t-color-text-primary",
  "placement-bottom-dark": "border-b-color-text-primary after:border-b-color-text-primary",
  "placement-left-dark": "border-l-color-text-primary after:border-l-color-text-primary",
  "placement-right-dark": "border-r-color-text-primary after:border-r-color-text-primary"
};
var __vue2_script = defineComponent({
  name: $prefix + "Tooltip",
  componentName: "Tooltip",
  props: _extends({}, $props, {
    adjustArrow: {
      type: Boolean,
      default: function _default() {
        return false;
      }
    },
    appendToBody: {
      type: Boolean,
      default: function _default2() {
        return true;
      }
    },
    arrowOffset: {
      type: Number,
      default: function _default3() {
        return 0;
      }
    },
    boundariesPadding: {
      type: Number,
      default: function _default4() {
        return 5;
      }
    },
    closeDelay: {
      type: Number,
      default: function _default5() {
        return 100;
      }
    },
    content: {
      type: [String, Object]
    },
    disabled: {
      type: Boolean
    },
    effect: {
      type: String,
      default: function _default6() {
        return "";
      }
    },
    enterable: {
      type: Boolean,
      default: function _default7() {
        return true;
      }
    },
    hideAfter: {
      type: Number,
      default: function _default8() {
        return 0;
      }
    },
    manual: {
      type: Boolean
    },
    modelValue: {
      type: Boolean
    },
    offset: {
      default: function _default9() {
        return 0;
      }
    },
    openDelay: {
      type: Number,
      default: function _default10() {
        return 0;
      }
    },
    placement: {
      type: String,
      default: function _default11() {
        return "bottom";
      }
    },
    popper: {},
    popperClass: {
      type: String
    },
    popperOptions: {
      default: function _default12() {
        return {
          gpuAcceleration: false,
          boundariesPadding: 10
        };
      }
    },
    pre: {
      type: Boolean
    },
    reference: {},
    renderContent: {
      type: Function
    },
    tabindex: {
      type: Number,
      default: function _default13() {
        return 0;
      }
    },
    transformOrigin: {
      type: [Boolean, String],
      default: function _default14() {
        return true;
      }
    },
    type: {
      type: String,
      validator: function validator(value) {
        return ~["normal", "warning", "error", "info", "success"].indexOf(value);
      }
    },
    visibleArrow: {
      type: Boolean,
      default: function _default15() {
        return true;
      }
    },
    genArrowByHtml: {
      type: Boolean,
      default: function _default16() {
        return true;
      }
    },
    zIndex: {
      type: String,
      default: function _default17() {
        return "next";
      }
    }
  }),
  setup: function setup(props, context) {
    return _setup({
      props,
      context,
      renderless,
      api
    });
  },
  render: function render() {
    var _this = this;
    var h = arguments[0];
    var getContent = function getContent2(vm) {
      var slotContent = vm.slots.content && vm.slots.content();
      if (slotContent) {
        return slotContent;
      }
      var attrContent;
      if (vm.renderContent) {
        attrContent = vm.renderContent(h, vm.content);
      } else if (vm.pre) {
        attrContent = vm.content ? h("pre", vm.content) : null;
      } else {
        attrContent = vm.content;
      }
      return attrContent;
    };
    Object.prototype.hasOwnProperty.call(this, "popperVM") || this.d({
      popperVM: {
        get: function get() {
          return createComponent({
            el: document.createElement("div"),
            component: {
              render: function render2() {
                var content = getContent(_this);
                var propsData = {
                  on: {
                    "after-leave": _this.doDestroy
                  }
                };
                var _mouseenter = function mouseenter() {
                  return _this.setExpectedState(true);
                };
                var _mouseleave = function mouseleave() {
                  _this.setExpectedState(false);
                  _this.debounceClose();
                };
                var xPlacement = _this.state.xPlacement || "";
                return h("transition", propsData, [h("div", {
                  "ref": "popper",
                  "attrs": {
                    "id": _this.state.tooltipId,
                    "appendToBody": _this.appendToBody,
                    "role": "tooltip",
                    "aria-hidden": _this.disabled || !_this.state.showPopper ? "true" : "false"
                  },
                  "directives": [{
                    name: "show",
                    value: !_this.disabled && _this.state.showPopper && content
                  }],
                  "class": mergeClass([classes.tooltip, _this.effect === "dark" ? "bg-color-text-primary text-color-text-inverse shadow-none" : "", _this.effect === "light" ? "bg-color-bg-1 text-color-text-primary shadow-md" : "", _this.disabled || !_this.state.showPopper ? "hidden" : "", _this.popperClass]),
                  "on": {
                    "mouseenter": function mouseenter() {
                      return _mouseenter();
                    },
                    "mouseleave": function mouseleave() {
                      return _mouseleave();
                    }
                  }
                }, [content, _this.visibleArrow ? h("div", {
                  "attrs": {
                    "x-arrow": true
                  },
                  "class": mergeClass([classes.arrow, classes["placement-" + xPlacement.split("-")[0]], _this.effect === "light" ? classes["placement-" + xPlacement.split("-")[0] + "-light"] : "", _this.effect === "dark" ? classes["placement-" + xPlacement.split("-")[0] + "-dark"] : ""])
                }) : ""])]);
              }
            }
          });
        }
      }
    });
    var stringifyBindClass = function stringifyBindClass2(bindClass, removeClassRE) {
      var trimStr = function trimStr2(str) {
        return str ? str.trim() : str;
      };
      var stringifyClassArr = function stringifyClassArr2(classArr) {
        var arr = [];
        classArr.forEach(function(item) {
          if (item && typeof item === "string") {
            arr.push(trimStr(item));
          } else if (item && typeof item === "object") {
            arr.push(stringifyClassObj(item));
          }
        });
        return arr.join(" ");
      };
      var stringifyClassObj = function stringifyClassObj2(classObj) {
        var arr = [];
        Object.keys(classObj).forEach(function(key) {
          if (classObj[key]) {
            arr.push(key);
          }
        });
        return arr.join(" ");
      };
      var className = "";
      if (bindClass) {
        if (typeof bindClass === "string") {
          className = className + trimStr(bindClass);
        } else if (Array.isArray(bindClass)) {
          className = className + stringifyClassArr(bindClass);
        } else if (typeof bindClass === "object") {
          className = className + stringifyClassObj(bindClass);
        }
      }
      return trimStr(className.replace(removeClassRE, ""));
    };
    var addTooltipClass = function addTooltipClass2(bindClass) {
      var className = stringifyBindClass(bindClass, /\btiny-tooltip\b/g);
      return "tiny-tooltip " + className;
    };
    var getFirstElement = function getFirstElement2() {
      var slots = _this.slots.default && _this.slots.default();
      if (!Array.isArray(slots))
        return null;
      var element = null;
      for (var index = 0; index < slots.length; index++) {
        var vnode = parseVnode(slots[index]);
        if (vnode && vnode.type) {
          element = vnode;
        }
      }
      return element;
    };
    var firstElement = getFirstElement();
    if (!firstElement)
      return null;
    var data = firstElement.data || firstElement.props || (firstElement.props = {});
    data.class = addTooltipClass(data.class);
    return firstElement;
  }
});
var __vue2_render, __vue2_staticRenderFns;
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, __vue2_render, __vue2_staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var mobileFirst = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  mobileFirst as default
};
